var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{attrs:{"app":"","flat":"","left":"","absolute":"","height":54}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.$store.dispatch('navigationDrawer/toggleModel')}}}),_c('v-spacer'),_c('account-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }